module.exports = __webpack_public_path__ + "media/configurations/X-P-39edc41c.png";